export const TROPHY_TYPE = {
  // POWER_SIGN
  STARTER: "STARTER",
  SOCIAL_MOTIVATOR: "SOCIAL_MOTIVATOR",
  MOTIVATION_AMBASSADOR: "MOTIVATION_AMBASSADOR",
  LESSON_SPRINTER: "LESSON_SPRINTER",
  DAILY_RECORD_HOLDER: "DAILY_RECORD_HOLDER",
  VIRTUAL_EXPLORER: "VIRTUAL_EXPLORER",
  PERSISTENT_WANDERER: "PERSISTENT_WANDERER",
  CONSTRUCTIVE_REVIEWER: "CONSTRUCTIVE_REVIEWER",
  // LEARNING_TROPHY
  MATH_MASTER: "MATH_MASTER",
  POLISH_MASTER: "POLISH_MASTER",
  ENGLISH_MASTER: "ENGLISH_MASTER",
  MATH_QUIZ_MARATHONER: "MATH_QUIZ_MARATHONER",
  POLISH_QUIZ_MARATHONER: "POLISH_QUIZ_MARATHONER",
  ENGLISH_QUIZ_MARATHONER: "ENGLISH_QUIZ_MARATHONER",
  MATH_PRECISE_MIND: "MATH_PRECISE_MIND",
  POLISH_PRECISE_MIND: "POLISH_PRECISE_MIND",
  ENGLISH_PRECISE_MIND: "ENGLISH_PRECISE_MIND",
  MATH_FLAWLESS_MIND: "MATH_FLAWLESS_MIND",
  POLISH_FLAWLESS_MIND: "POLISH_FLAWLESS_MIND",
  ENGLISH_FLAWLESS_MIND: "ENGLISH_FLAWLESS_MIND",
  MATH_VIDEO_ENTHUSIAST: "MATH_VIDEO_ENTHUSIAST",
  POLISH_VIDEO_ENTHUSIAST: "POLISH_VIDEO_ENTHUSIAST",
  ENGLISH_VIDEO_ENTHUSIAST: "ENGLISH_VIDEO_ENTHUSIAST",
  MATH_DIDACTIC_COLLECTOR: "MATH_DIDACTIC_COLLECTOR",
  POLISH_DIDACTIC_COLLECTOR: "POLISH_DIDACTIC_COLLECTOR",
  ENGLISH_DIDACTIC_COLLECTOR: "ENGLISH_DIDACTIC_COLLECTOR",
  // BIDIRECTIONAL_TROPHY
  TWO_SUBJECT_MASTER_MAT_ENG: "TWO_SUBJECT_MASTER_MAT_ENG",
  TWO_SUBJECT_MASTER_MAT_POL: "TWO_SUBJECT_MASTER_MAT_POL",
  TWO_SUBJECT_MASTER_ENG_POL: "TWO_SUBJECT_MASTER_ENG_POL",
  TWO_SECTION_EXPERT_MAT_ENG: "TWO_SECTION_EXPERT_MAT_ENG",
  TWO_SECTION_EXPERT_MAT_POL: "TWO_SECTION_EXPERT_MAT_POL",
  TWO_SECTION_EXPERT_ENG_POL: "TWO_SECTION_EXPERT_ENG_POL",
  QUIZ_DUO_MAT_ENG: "QUIZ_DUO_MAT_ENG",
  QUIZ_DUO_MAT_POL: "QUIZ_DUO_MAT_POL",
  QUIZ_DUO_ENG_POL: "QUIZ_DUO_ENG_POL",
  FLAWLESS_DUO_MAT_ENG: "FLAWLESS_DUO_MAT_ENG",
  FLAWLESS_DUO_MAT_POL: "FLAWLESS_DUO_MAT_POL",
  FLAWLESS_DUO_ENG_POL: "FLAWLESS_DUO_ENG_POL",
  VIDEO_DUO_MAT_ENG: "VIDEO_DUO_MAT_ENG",
  VIDEO_DUO_MAT_POL: "VIDEO_DUO_MAT_POL",
  VIDEO_DUO_ENG_POL: "VIDEO_DUO_ENG_POL",
  DIDACTIC_DUO_MAT_ENG: "DIDACTIC_DUO_MAT_ENG",
  DIDACTIC_DUO_MAT_POL: "DIDACTIC_DUO_MAT_POL",
  DIDACTIC_DUO_ENG_POL: "DIDACTIC_DUO_ENG_POL",
  // INTERDISCIPLINARY_TROPHY
  THREE_SUBJECT_MASTER: "THREE_SUBJECT_MASTER",
  THREE_SECTION_EXPERT: "THREE_SECTION_EXPERT",
  QUIZ_TRIATHLON: "QUIZ_TRIATHLON",
  FLAWLESS_TRIO: "FLAWLESS_TRIO",
  VIDEO_TRIAD: "VIDEO_TRIAD",
  DIDACTIC_TRIAD: "DIDACTIC_TRIAD",
} as const;

export type TrophyType = (typeof TROPHY_TYPE)[keyof typeof TROPHY_TYPE];
